var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonsDialogue',{attrs:{"is-visible":_vm.isVisible,"title":_vm.title,"message":_vm.message}},[_c('Button',{attrs:{"text":"No","on-click":() => _vm.$emit('no')}}),_c('Button',{attrs:{"text":"Yes","on-click":() => _vm.$emit('yes'),"is-warning":"","is-loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }